import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem, CommandShortcut } from "./ui/command";
import {
  Home, MessageSquare, GraduationCap, StickyNote, FlaskConical, Mic2, Network,
  CalendarDays, Search as SearchIcon, Youtube, BookOpen, Settings, Timer, Sunrise,
} from "lucide-react";

const ITEMS = [
  { to: "/app/home", label: "Home", icon: Home, group: "Navigate" },
  { to: "/app/chat", label: "Ask ARIA", icon: MessageSquare, group: "Navigate" },
  { to: "/app/learn", label: "Learn", icon: GraduationCap, group: "Navigate" },
  { to: "/app/notes", label: "Notes", icon: StickyNote, group: "Navigate" },
  { to: "/app/documents", label: "Research", icon: FlaskConical, group: "Navigate" },
  { to: "/app/interviews", label: "Interviews", icon: Mic2, group: "Navigate" },
  { to: "/app/knowledge", label: "Knowledge", icon: Network, group: "Navigate" },
  { to: "/app/plan", label: "Countdown plan", icon: Timer, group: "Navigate" },
  { to: "/app/warmup", label: "Interview day warm-up", icon: Sunrise, group: "Navigate" },
  { to: "/app/calendar", label: "Calendar", icon: CalendarDays, group: "Navigate" },
  { to: "/app/search", label: "Search", icon: SearchIcon, group: "Navigate" },
  { to: "/app/learn", label: "Connect YouTube", icon: Youtube, group: "Connect" },
  { to: "/app/turbolearn", label: "Connect TurboLearn", icon: BookOpen, group: "Connect" },
  { to: "/app/notes", label: "Add a note", icon: StickyNote, group: "Connect" },
  { to: "/app/settings", label: "Settings", icon: Settings, group: "Account" },
];

export function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const onKeyDown = useCallback((e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
      e.preventDefault();
      setOpen((v) => !v);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);

  const go = (to) => { setOpen(false); navigate(to); };

  const groups = ITEMS.reduce((acc, i) => { (acc[i.group] = acc[i.group] || []).push(i); return acc; }, {});

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Jump anywhere in ARIA…" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No matches.</CommandEmpty>
        {Object.entries(groups).map(([group, items]) => (
          <CommandGroup key={group} heading={group}>
            {items.map((i) => (
              <CommandItem key={i.label} onSelect={() => go(i.to)} data-testid={`cmdk-${i.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <i.icon size={15} className="mr-1" />
                <span>{i.label}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}

export function CommandPaletteHint() {
  return (
    <span className="hidden lg:inline-flex items-center gap-1 text-[10px] font-mono text-[var(--aria-text-muted)] border border-[var(--aria-border)] rounded px-1.5 py-0.5">
      <CommandShortcutIcon /> K
    </span>
  );
}
function CommandShortcutIcon() { return <span>⌘</span>; }
